const TokenHome = () => import(/* webpackChunkName: "group-users" */ '../_views/TokenHome')
const CadastroToken = () => import(/* webpackChunkName: "group-users" */ '../_views/CadastroToken')

import { permissoesToken } from '../../../utils/permissoesUsuarios'

export default [
  {
    path: 'token',
    component: TokenHome,
    meta: { requiresAuth: true, permissions: [...permissoesToken] },
    name: 'TokenHome',
  },
  {
    path: 'token/criar',
    component: CadastroToken,
    meta: { requiresAuth: true, permissions: [...permissoesToken] },
    name: 'TokenHome/criar',
  },
]
